"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.formatAssigned = exports.postProcessing = exports.statuses = void 0;
var T = __importStar(require("./type"));
exports.statuses = [
    {
        id: T.Status.pending,
        name: 'Pending'
    },
    {
        id: T.Status.active,
        name: 'Active'
    },
    {
        id: T.Status.inactive,
        name: 'Inactive'
    }
];
exports.postProcessing = function (item) {
    var status = exports.statuses.filter(function (x) { return x.id === item.status.id; })[0];
    return __assign(__assign({}, item), { status: status, instance: {
            uuid: item.instance.uuid,
            name: ''
        } });
};
exports.formatAssigned = function (input) {
    return input.map(function (ip) {
        var assigned = ip.PermissionInstance &&
            ip.PermissionInstance.length &&
            ip.PermissionInstance[0].UserPermission &&
            ip.PermissionInstance[0].UserPermission.length
            ? ip.PermissionInstance[0].UserPermission[0].uuid
            : undefined;
        return {
            id: ip.uuid,
            name: ip.name,
            assigned: assigned
        };
    });
};
